import React from "react";
import { Box } from "@mui/material";
import { FlowsMenu } from "./components/FlowsMenu";
import { TransactionsView } from "./components/Transactions/TransactionsView";
import { AutomationFlowEditor } from "./components/AutomationFlow/AutomationFlowEditor";
import { FlowsManagerView } from "./components/FlowsManager/FlowsManagerView";
import { useFlowsTab } from "./useFlowsTab";

export const FlowsTab: React.FC = () => {
  const { currentSubView } = useFlowsTab();

  const renderContent = () => {
    switch (currentSubView) {
      case "transactions":
        return <TransactionsView />;
      case "automation-flow":
        return <AutomationFlowEditor />;
      case "flows-manager":
        return <FlowsManagerView />;
      case "menu":
      default:
        return <FlowsMenu />;
    }
  };

  return (
    <Box sx={{ height: "100%", p: 2 }}>
      {renderContent()}
    </Box>
  );
};
